import api from "../index";

export const GetAllBannerListApi = () => api.post('bannerlist');
export const AddBannerApi = (data, headers) => api.post('bannercreate', data, headers);
export const UpdateBannerApi = (data, headers) => api.post('banneredit', data, headers);
export const DeleteBannerApi = (data) => api.post('bannerdelete', data);